<template>
  <div class="col-12 col-lg-6">
    <div class="tit page">  
      <h1>Comprovante de Endereço</h1>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-8 col-xl-7">
        <form>
          <div class="form-group">
            <files-input :files="arquivos" :accept="formatosAceitos"
              :uploadEndpoint="uploadEndpoint" @files-changed="onFilesChanged"/>
          </div>
          <div class="text-center fixedOptions">
            <button class="btn btn-primary" @click="onSubmit">Próximo <img src="../../assets/images/angle-right.svg"></button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import FilesInput from '@/components/FilesInput'
import ArrayHelper from '@/utils/array-helper'

export default {
  components: {
    FilesInput
  },
  data() {
    const pessoal = this.currentUser.Pessoal
    return {
      /* eslint-disable */  
      uploadEndpoint: process.env.API_NODE+'/files',
      formatosAceitos: 'application/pdf, image/jpeg, image/png',
      arquivos: pessoal.ArquivoComprovanteEndereco || [null]
    }
  },
  computed: {
    arquivosRecebidos: function() {
      return this.arquivos.filter(arquivo => {
        return arquivo != null && arquivo != undefined
      })
    }
  },
  props: {
    currentUser: {required: true, type: Object}
  },
  methods: {
    onFilesChanged(updatedFiles) {
      this.arquivos = updatedFiles
    },
    removeFile(index) {
      this.arquivos.splice(index, 1)
    },
    clearFile(index) {
      this.$set(this.arquivos, index, null)
    },
    validate() {
      if(this.arquivosRecebidos.length > 0) {
        return {isValid: true, errors: []}
      } else {
        return {isValid: false, errors: ['O envio do comprovande de endereço é obrigatório']}
      }
    },
    onSubmit(e) {
      e.preventDefault()
      const validation = this.validate()

      if(validation.isValid) {
        
        this.currentUser.Pessoal.ArquivoComprovanteEndereco = this.arquivosRecebidos
        
        this.$emit('on-submit', {Pessoal: this.currentUser.Pessoal})
      } else {
        this.$Notify.error({
          title: "Dados Inválidos",
          message: ArrayHelper.toSentence(validation.errors)})
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationPersonalLoan/AddressDocumentStep.vue